import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "@/components/Logo";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) nav("/admin", { replace: true });
    else setError(res.error || "Login failed");
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center jewel-bg text-ivory p-6"
      style={{ color: "var(--ivory)" }}
    >
      <div className="w-full max-w-md">
        <div className="text-center">
          <Logo size={140} />
          <h1 className="font-serif text-3xl md:text-4xl mt-6 tracking-tight">
            Admin sign-in
          </h1>
        </div>

        <form onSubmit={submit} className="mt-10 space-y-6">
          <div>
            <label className="block text-[10px] tracking-[0.35em] uppercase text-ivory/60 mb-1">
              Email
            </label>
            <input
              data-testid={ADMIN.loginEmail}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-0 border-b border-[#D4AF37]/60 py-2 focus:outline-none focus:border-[#D4AF37] text-ivory"
              style={{ color: "var(--ivory)" }}
              placeholder="edhix26@brushmaster.art"
            />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.35em] uppercase text-ivory/60 mb-1">
              Password
            </label>
            <input
              data-testid={ADMIN.loginPassword}
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-0 border-b border-[#D4AF37]/60 py-2 focus:outline-none focus:border-[#D4AF37] text-ivory"
              style={{ color: "var(--ivory)" }}
            />
          </div>
          {error && (
            <div
              data-testid={ADMIN.loginError}
              className="text-sm text-[#f4c9c9]"
            >
              {error}
            </div>
          )}
          <button
            data-testid={ADMIN.loginSubmit}
            type="submit"
            disabled={submitting}
            className="w-full btn-gold h-12 tracking-[0.3em] text-[11px] uppercase font-medium"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-center pt-2">
            <Link
              to="/"
              className="text-[10px] tracking-[0.4em] uppercase text-ivory/50 hover:text-[#D4AF37]"
            >
              ← Back to site
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
